import { render } from "./features.vue?vue&type=template&id=0efc0ecc&scoped=true"
import script from "./features.vue?vue&type=script&lang=js"
export * from "./features.vue?vue&type=script&lang=js"

import "./features.vue?vue&type=style&index=0&id=0efc0ecc&scoped=true&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0efc0ecc"]])

export default __exports__